import { Grid } from '@material-ui/core';
import { ModalWithButtons } from '../../components/ModalWithButtons/ModalWithButtons.component';
import Annotations from './AnnotationsAssignment.component';

interface AnnotationsAssignmentModalProps {
  sheetId: string
  onClose: () => void;
}

export const AnnotationsAssignmentModal: React.FC<AnnotationsAssignmentModalProps> = ({ sheetId, onClose }) => {
  const modalStyle = {
    width: '90%',
    height: '90%',
    left: '5%',
    top: '5%',
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={onClose}
        open={true}
        title={' '}
        fullScreen
        isPageInModal
        pageContainerStyle={modalStyle}
        isHideBackdrop={false}
      >
        <Grid>
          <Grid item xs={12}>
            <Annotations sheetId={sheetId} />
          </Grid>
        </Grid>
      </ModalWithButtons>
    </>
  );
};
